const _env = process.env;
export const BASE_URL = _env.VUE_APP_HOST_API;
